let autocomplete;
let address1Field;
let address2Field;
let cityField;
let stateField;
let postalField;
function initAutocomplete() {
	address1Field = document.querySelector('#mod_billing_address_1');
	address2Field = document.querySelector('#mod_billing_address_2');
	cityField = document.querySelector('#mod_billing_city');
	stateField = document.querySelector('#mod_billing_state');
	postalField = document.querySelector('#mod_billing_postcode');
	if (address1Field === null) {
		address1Field = document.querySelector('#billing_address_1');
	}
	if (address2Field === null) {
		address2Field = document.querySelector('#billing_address_2');
	}
	if (cityField === null) {
		cityField = document.querySelector('#billing_city');
	}
	if (stateField === null) {
		stateField = document.querySelector('#billing_state');
	}
	if (postalField === null) {
		postalField = document.querySelector('#billing_postcode');
	}
	if (address1Field === null) {
		address1Field = document.querySelector('#shipping_address_1');
	}
	if (address2Field === null) {
		address2Field = document.querySelector('#shipping_address_2');
	}
	if (cityField === null) {
		cityField = document.querySelector('#shipping_city');
	}
	if (stateField === null) {
		stateField = document.querySelector('#shipping_state');
	}
	if (postalField === null) {
		postalField = document.querySelector('#shipping_postcode');
	}

	//address1Field.style.backgroundColor = 'purple';

	autocomplete = new google.maps.places.Autocomplete(address1Field, {
		componentRestrictions: {
			country: ['us'],
		},
		fields: ['address_components', 'geometry'],
		types: ['address'],
	});
	//address1Field.focus();

	autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddress() {
	const place = autocomplete.getPlace();
	let address1 = '';
	let postcode = '';
	// http://goo.gle/3l5i5Mr
	for (const component of place.address_components) {
		const componentType = component.types[0];
		switch (componentType) {
			case 'street_number': {
				address1 = `${component.long_name} ${address1}`;
				break;
			}
			case 'route': {
				address1 += component.short_name;
				break;
			}
			case 'postal_code': {
				postcode = `${component.long_name}${postcode}`;
				break;
			}
			case 'locality': {
				cityField.value = component.long_name;
				break;
			}
			case 'administrative_area_level_1': {
				if (stateField !== null) {
					stateField.value = component.short_name;
				}
				break;
			}
			// case 'country':
			// 	document.querySelector('#country').value = component.long_name;
			// 	break;
		}
	}
	address1Field.value = address1;
	postalField.value = postcode;
	address2Field.focus();
}
window.initAutocomplete = initAutocomplete;
